import { useGetCustomEventsCount } from 'api/CustomEventsAPI';
import { ApiError } from 'services/api';
import { addNegativeToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { MergedCustomEvent } from '../types';

type Props = {
  customEvents: MergedCustomEvent[];
  retentionPeriod: number;
};

export const useDeletionCount = ({ customEvents, retentionPeriod }: Props) => {
  const dispatch = useDispatch();

  const customEventsNameArray = customEvents.map((event) => event.eventName);
  const includeNamesJs = `{"includeNames": ${JSON.stringify(customEventsNameArray)}}`;

  const queryParams = {
    includeNames: includeNamesJs,
    ageInDays: retentionPeriod < 1 ? 3650 : retentionPeriod,
  };

  const queryOptions = {
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    onError: (err: ApiError) => {
      const { response } = err;
      dispatch(addNegativeToast(response?.data));
    },
  };

  const {
    data,
    isLoading,
    refetch: refetchCount,
  } = useGetCustomEventsCount(queryParams, queryOptions);

  const handleFetchCount = () => {
    if (!isLoading && retentionPeriod > 0) {
      refetchCount();
    }
  };

  useDebouncedEffect(handleFetchCount, [includeNamesJs, retentionPeriod], {
    debounceTimeout: 500,
    skipEffectOnMount: false,
  });

  return {
    deletionCount: data?.count,
    isLoadingDeletionCount: isLoading,
  };
};
